// extracted by mini-css-extract-plugin
module.exports = {"wrapIcon":"information_wrapIcon__1p6EE","informationList":"information_informationList__1n_2w"};